import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import Tooltip from 'app-ui-componentlibrary/dist/componentLibrary/layout/Tooltip';

export const ConfigTooltip = connectDynamic(Tooltip);
